/* Polsk katalog for locale-autopilot-no.js (del 2 av 2).
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('pl', {
  'ap.monthControl.edit.supplierInvoice': 'Zmień fakturę dostawcy',
  'ap.monthControl.edit.fallbackWithLabel': 'Zmień: {{label}}',
  'ap.monthControl.edit.fallback': 'Zmień',
  'ap.monthControl.vatAmount': 'VAT {{amount}}',
  'ap.monthControl.vatAmountWithRate': 'VAT {{amount}} ({{rate}} %)',
  'ap.monthControl.vatAmountMissing': 'Nie znaleziono kwoty VAT ({{rate}} %)',
  'ap.monthControl.invoiceNumber': 'Faktura {{number}}',
  'ap.monthControl.linkedBankLineAmount': 'linia bankowa {{amount}}',
  'ap.monthControl.reopenNote': 'Linia bankowa została ponownie otwarta. Sprawdź ją i zatwierdź ponownie, aby ją zaksięgować.',
  'ap.monthControl.reopenSuccess': 'Linia bankowa została ponownie otwarta',
  'ap.monthControl.reopenError': 'Nie udało się ponownie otworzyć linii bankowej.',
  'ap.monthControl.reopenMatchSuccess': 'Powiązanie zostało ponownie otwarte. Pierwotne księgowanie nie zostało zmienione.',
  'ap.monthControl.reopenMatchError': 'Nie udało się ponownie otworzyć powiązania.',
  'ap.monthControl.moreMenu.trigger': 'Inne',
  'ap.monthControl.moreMenu.close': 'Zamknij menu',
  'ap.monthControl.choice.asset': 'Aktywo',
  'ap.monthControl.contact.customerLabel': 'Klient',
  'ap.monthControl.contact.supplierLabel': 'Dostawca',
  'ap.monthControl.contact.requiredBeforeApprove': '{{contact}} — należy zapisać przed zatwierdzeniem linii.',
  'ap.monthControl.action.reopen': 'Otwórz ponownie',
  'ap.monthControl.action.correct': 'Popraw',
  'ap.monthControl.action.reverse': 'Odwróć',
  'ap.monthControl.action.approve': 'Zatwierdź',
  'ap.monthControl.asset.reconciledNote': 'Uzgodniono z zarejestrowanym aktywem: {{description}}',
  'ap.monthControl.asset.linkedSuccess': 'Aktywo zostało powiązane z linią bankową',
  'ap.monthControl.asset.linkError': 'Aktywo zostało zapisane, ale nie udało się powiązać linii bankowej.',
  'ap.monthControl.receipt.fallbackName': 'Dokument',
  'ap.monthControl.receipt.view': 'Pokaż dokument',
  'ap.monthControl.receipt.duplicateNote': '{{label}}. Zatwierdź powiązanie, aby zakończyć linię bankową bez nowego księgowania.',
  'ap.monthControl.receipt.detachTitle': 'Usuwa tylko powiązanie. Dokument wraca do skrzynki odbiorczej.',
  'ap.monthControl.receipt.detach': 'Odłącz',
  'ap.monthControl.receipt.rowLabel': 'Dokument {{number}}',
  'ap.monthControl.contact.supplierNameRequired': 'Nazwa dostawcy jest wymagana.',
  'ap.monthControl.contact.customerNameRequired': 'Nazwa klienta jest wymagana.',
  'ap.monthControl.contact.supplierRegistryUnavailable': 'Rejestr dostawców jest niedostępny.',
  'ap.monthControl.contact.customerRegistryUnavailable': 'Rejestr klientów jest niedostępny.',
  'ap.monthControl.contact.supplierSaved': 'Dostawca został zapisany.',
  'ap.monthControl.contact.customerSaved': 'Klient został zapisany.',
  'ap.monthControl.contact.supplierSaveError': 'Nie udało się zapisać dostawcy.',
  'ap.monthControl.contact.customerSaveError': 'Nie udało się zapisać klienta.',
  'ap.monthControl.contact.updateSupplierTitle': 'Zaktualizuj dostawcę',
  'ap.monthControl.contact.newSupplierTitle': 'Nowy dostawca',
  'ap.monthControl.contact.editCustomerTitle': 'Edytuj klienta',
  'ap.monthControl.contact.newCustomerTitle': 'Nowy klient',
  'ap.monthControl.contact.saving': 'Zapisywanie...',
  'ap.monthControl.contact.update': 'Zaktualizuj',
  'ap.monthControl.contact.save': 'Zapisz',
  'ap.monthControl.contact.saved': 'Zapisano',
  'ap.monthControl.contact.archived': 'Zarchiwizowano',
  'ap.monthControl.contact.notSavedOptional': 'Nie zapisano · opcjonalne',
  'ap.monthControl.contact.edit': 'zmień',
  'ap.monthControl.contact.add': 'Dodaj',
  'ap.monthControl.contact.saveSupplier': 'Zapisz dostawcę',
  'ap.monthControl.summary.stick': 'Przypnij górną kartę podczas przewijania',
  'ap.monthControl.summary.unstick': 'Odepnij górną kartę',
  'ap.monthControl.summary.expand': 'Pokaż całą górną kartę',
  'ap.monthControl.summary.collapse': 'Zminimalizuj górną kartę',
  'ap.monthControl.summary.opening': 'Otwarcie',
  'ap.monthControl.summary.closing': 'Zamknięcie',
  'ap.monthControl.summary.deviation': 'Odchylenie',
  'ap.monthControl.summary.remaining': 'Pozostało',
  'ap.monthControl.summary.bankLines': 'Linie bankowe',
  'ap.monthControl.summary.allHandled': 'Wszystko obsłużone',
  'ap.monthControl.summary.remainingLinesOne': 'Linie: {{count}}',
  'ap.monthControl.summary.remainingLinesMany': 'Linie: {{count}}',
  'ap.whatShouldDo': 'Co ma zrobić SuperPlumma?',
  'ap.openBankingHelp': 'SuperPlumma automatycznie pobiera Twoje transakcje bankowe przez bezpieczne połączenie z bankiem (Open Banking) i łączy je z dokumentami. Bez połączenia musisz ręcznie przesyłać wyciągi.',
  'ap.dataExists': 'Dane dostępne',
  'ap.notConnected': 'Nie połączono',
  'ap.switchBank': 'Zmień bank',
  'ap.connectBank': 'Połącz z bankiem',
  'ap.monthPickerHelp': 'Wybierz miesiąc, nad którym chcesz pracować. Lista pokazuje tylko pracę należącą do tego miesiąca. Zielony znacznik oznacza, że nic nie zostało; czerwony oznacza, że miesiąc minął, a coś pozostało niezrobione.',
  'ap.monthOverview': 'Przegląd miesiąca',
  'ap.prevMonth': 'Poprzedni miesiąc',
  'ap.nextMonth': 'Następny miesiąc',
  'ap.noActiveAgents': 'Brak aktywnych agentów',
  'ap.activateAgents': 'Aktywuj agentów',
  'ap.monthSummaryHelp': 'Praca dla wybranego miesiąca i działania dotyczące całego roku.',
  'ap.agents': 'Agenci',
  'ap.agentCount': 'Agenci: {{count}}',
  'ap.agentCountPlural': 'Agenci: {{count}}',
  'ap.totalTasksHelp': 'Liczba agentów, których faktycznie znajdziesz na liście poniżej. Agenci, którzy sprawdzili i nic nie znaleźli, nie są uwzględnieni.',
  'ap.readyForApproval': 'Do sprawdzenia',
  'ap.readyForApprovalHelp': 'Zadania czekające na Ciebie — albo dlatego, że coś trzeba sprawdzić, albo dlatego, że przeglądowi brakuje podpisu. Nie są zakończone, dopóki ich nie obejrzysz.',
  'ap.approvedHelp': 'Zadania sprawdzone lub zatwierdzone. Zatwierdzona kontrola nie oznacza, że coś zostało zaksięgowane, wysłane lub złożone. Status i szczegóły znajdziesz w zadaniu.',
  'ap.approveAllHelp': 'Zatwierdza pojedyncze propozycje, które AI Księgowy uznał za gotowe — nie cały miesiąc. Księgowanie następuje później osobnym przyciskiem Zaksięguj.',
  'ap.approveAllGreen': 'Zatwierdź gotowe',
  'ap.approveProposals': 'Zatwierdź propozycje ({{count}})',
  'ap.approveAndBookProposals': 'Zatwierdź i zaksięguj propozycje ({{count}})',
  'ap.book': 'Zaksięguj propozycje ({{count}})',
  'ap.bookHelp': 'Księguje zatwierdzone propozycje. To jedyny przycisk, który zmienia liczby, i nie można go cofnąć jednym kliknięciem.',
  'ap.nothingToCheck': 'Nic do sprawdzenia',
  'ap.autoApproved': 'Brak punktów kontrolnych',
  'ap.autoApprovedDetail': 'Nic do sprawdzenia',
  'ap.agent.beforeBank.title': 'Uzgodnienie bankowe zaczyna się później niż {{month}}',
  'ap.agent.beforeBank.desc': 'Konto bankowe ma saldo otwarcia na dzień {{date}}, a Plumme uzgadnia od następnego dnia.',
  'ap.agent.beforeBank.descNoDate': 'Konto bankowe jest uzgadniane dopiero od późniejszej daty.',
  'ap.agent.beforeBank.detail': 'Data jest zapisana przy koncie bankowym w Ustawieniach. Jeśli Plumme ma uzgodnić również ten miesiąc, ustaw wcześniejszą datę początkową i prześlij wyciąg w sekcji Bank.',
  'ap.agent.beforeBank.action': 'Otwórz bank',
  'ap.monthImported': 'Prowadzone w innym systemie',
  'ap.monthOverdue': 'Przekroczono termin w tym miesiącu',
  'ap.monthReviewHint': 'Niezakończone — w tym miesiącu coś pozostało',
  'ap.monthReviewed': '{{month}} — przejrzano',
  'ap.agent.imported.title': '{{month}} — prowadzone w innym systemie',
  'ap.agent.imported.desc': 'Księgowość została przejęta później. AI Księgowy nie sprawdził tego miesiąca.',
  'ap.agent.imported.detail': 'Dane i dokumenty za ten okres znajdują się w archiwum importu. Należy je sprawdzić względem starego systemu, a nie względem Plumme.',
  'ap.agent.imported.action': 'Otwórz archiwum',
  'ap.agent.invoice.titleEmpty': 'Brak faktur w {{year}}',
  'ap.agent.invoice.descEmpty': 'W Plumme nie zarejestrowano faktur za ten okres, więc nie ma nic do sprawdzenia.',
  'ap.agent.quality.titleEmpty': 'Brak zakupów w {{year}}',
  'ap.agent.quality.descEmpty': 'W Plumme nie zarejestrowano zakupów za ten okres, więc nie ma czego sprawdzać.',
  'ap.agent.match.titleEmpty': 'Brak pozycji bankowych w {{year}}',
  'ap.agent.match.descEmpty': 'Żaden wyciąg bankowy nie obejmuje tego okresu, więc nie ma czego powiązać.',
  'ap.agent.inbox.detailHistoric': 'Część dowodów księgowych ({{count}}) ma datę sprzed przejęcia księgowości. Prawdopodobnie zostały już zaksięgowane w poprzednim systemie i nie są księgowane tutaj — należy je powiązać jako dokumentację.',
  'ap.agent.dunning.detailImported': 'Część pozycji ({{count}}) pochodzi z importu księgowego i nie ma ich na liście faktur. Plumme nie może ich wysłać ani wysłać monitu — prowadź je w poprzednim systemie lub zarejestruj tutaj jako rozliczone.',
  'ap.agent.dunning.lineImported': 'Z importu księgowego · faktura {{num}} · nie można wysłać monitu z Plumme',
  'ap.agent.dunning.importedParty': 'Klient z importu',
  'ap.require.noEmployees': 'Nie zarejestrowano aktywnych pracowników.',
  'ap.require.noVat': 'Firma nie jest zarejestrowana jako podatnik VAT.',
  'ap.yearScope': 'Dotyczy całego roku',
  'ap.yearScopeHelp': 'Zadania, które nie należą do jednego miesiąca — zaległe należności, terminy, rejestry i zamknięcie roku.',
  'ap.showAllYearTasks': 'Pokaż wszystkie ({{count}})',
  'ap.showFewerYearTasks': 'Pokaż mniej',
  'ap.monthEmpty': 'W okresie {{month}} nic nie zostało do zrobienia.',
  'ap.agent.reconcile.titleMonth': '{{month}}: nieuzgodniony',
  'ap.agent.reconcile.titleMonthDone': '{{month}}: uzgodniony',
  'ap.agent.reconcile.titleMonthOpen': '{{month}}: jeszcze się nie zakończył',
  'ap.agent.reconcile.descMonth': 'Wyciąg z rachunku firmowego za {{month}} nie jest zaksięgowany ani zarchiwizowany w Banku.',
  'ap.agent.reconcile.descMonthDone': 'Wyciąg z rachunku firmowego za {{month}} jest zaksięgowany i zarchiwizowany.',
  'ap.agent.reconcile.descMonthOpen': 'Miesiąc zostanie uzgodniony, gdy się zakończy i wyciąg bankowy zostanie zaimportowany.',
  'ap.agent.reconcile.waitingReason': 'Oczekuje na koniec miesiąca',
  'ap.agent.match.titleWaiting': '{{month}}: jeszcze się nie zakończył',
  'ap.agent.match.descWaiting': 'Agent dowodów księgowych rozpocznie kontrolę bankową po zakończeniu miesiąca, gdy będzie można zaimportować wyciąg bankowy.',
  'ap.agent.match.detailWaiting': 'Na razie nie brakuje żadnego wyciągu bankowego. Zadanie stanie się aktualne po zakończeniu miesiąca.',
  'ap.agent.payroll.titleWaiting': 'Wynagrodzenia za {{period}} oczekują',
  'ap.agent.payroll.descWaiting': 'Okres jeszcze się nie rozpoczął. Agent płac zajmie się tym, gdy miesiąc stanie się aktualny.',
  'ap.agent.payroll.waitingReason': 'Oczekuje na rozpoczęcie okresu',
  'ap.agent.payroll.titleReady': 'Można utworzyć listę płac za {{period}}',
  'ap.agent.payroll.descReady': 'Stałe pozycje płacowe są gotowe do utworzenia jako szkic do sprawdzenia.',
  'ap.agent.reconcile.disabledTitle': 'Uzgadnianie nie jest aktywne',
  'ap.agent.reconcile.disabledDesc': 'Żaden aktywny rachunek bankowy nie jest ustawiony do uzgadniania.',
  'ap.agent.reconcile.disabledDetail': 'To rozwiązanie dla firm, które korzystają z rachunku prywatnego i zdecydowały, że rachunek nie będzie uzgadniany w Banku.',
  'ap.agent.match.disabledTitle': 'Dopasowywanie dowodów księgowych nie jest aktywne',
  'ap.agent.match.disabledDesc': 'Żaden aktywny rachunek bankowy nie jest ustawiony do uzgadniania.',
  'ap.agent.match.disabledDetail': 'Gdy firma korzysta z rachunku prywatnego bez uzgadniania bankowego, nie ma wyciągu firmowego, z którym można powiązać dowody księgowe.',
  'ap.showDetails': 'Pokaż szczegóły',
  'ap.showTask': 'Pokaż zadanie',
  'ap.quiet.title': 'Agenci ({{count}}) nie znaleźli nic do sprawdzenia',
  'ap.quiet.titleClear': 'Agenci ({{count}}) nie znaleźli nic do dalszej obsługi',
  'ap.quiet.titleOne': '{{agent}} nie znalazł nic do sprawdzenia',
  'ap.quiet.titleClearOne': '{{agent}} nie znalazł nic do dalszej obsługi',
  'ap.quiet.someApproved': 'Zatwierdzono: {{count}}',
  'ap.require.noBankReconciliation': 'Żaden aktywny rachunek bankowy nie jest ustawiony do uzgadniania.',
  'ap.agent.awaitBank.title': 'Oczekiwanie na wyciąg bankowy za {{month}}',
  'ap.agent.awaitBank.desc': 'Prześlij wyciąg z rachunku za ten okres. Bez niego nie ma pozycji bankowych, z którymi można powiązać dowody księgowe lub je uzgodnić.',
  'ap.agent.awaitBank.detail': 'Praca z bankiem przebiega w kolejności: najpierw wyciąg, potem powiązanie dowodów księgowych i uzgodnienie miesiąca.',
  'ap.agent.awaitBank.action': 'Otwórz bank',
  'ap.agent.awaitBank.reason': 'Brak wyciągu bankowego za okres',
  'ap.uploadStatement': 'Prześlij wyciąg',
  'ap.agent.awaitBank.descAccounts': 'Liczba rachunków bez wyciągu za okres: {{count}}.',
  'ap.agent.awaitBank.reasonAccounts': 'Brak wyciągu na rachunkach: {{count}}',
  'ap.agent.awaitBank.account': 'Rachunek bankowy',
  'ap.taskColumnHelp': 'Co zrobiła SuperPlumma — np. zaksięgowała transakcje bankowe, powiązała dowody księgowe, zarejestrowała aktywa lub przeprowadziła wypłatę wynagrodzeń.',
  'ap.task': 'Zadanie',
  'ap.descriptionColumn': 'Opis',
  'ap.statusColumn': 'Status',
  'ap.actionColumn': 'Działanie',
  'ap.statusColumnHelp': 'Zielony oznacza aktualne. Żółty oznacza, że coś należy sprawdzić, zanim przejdziesz dalej. Sprawdź oznaczone wiersze.',
  'ap.actionColumnHelp': 'Naciśnij „Pokaż”, aby zobaczyć podstawę zadania, lub „Otwórz”, aby przejść do strony, na której możesz kontynuować pracę.',
  'ap.task.actionLabel': 'Przejdź do',
  'ap.task.detailsLabel': 'Zobacz szczegóły',
  'ap.agent.bank.disabledTitle': 'Uzgadnianie bankowe nie jest aktywne',
  'ap.agent.bank.disabledDesc': 'Żaden aktywny rachunek bankowy nie jest ustawiony do uzgadniania.',
  'ap.agent.bank.disabledDetail': 'To rozwiązanie dla firm, które korzystają z rachunku prywatnego i zdecydowały, że rachunek nie będzie uzgadniany w Banku.',
  'ap.agent.bank.action': 'Otwórz bank',
  'ap.agent.bank.reopenDetail': 'Otwórz ponownie uzgodnienie, jeśli coś trzeba poprawić. Widok bankowy pojawi się wtedy w tym samym oknie.',
  'ap.agent.bank.title': 'Uzgadnianie bankowe: pozycje do sprawdzenia: {{count}}',
  'ap.agent.bank.titleNoStatement': 'Uzgadnianie bankowe: brak wyciągu bankowego',
  'ap.agent.bank.desc': 'Obsłużone pozycje: {{handled}}, pozostało: {{remaining}}.',
  'ap.agent.bank.descNoStatement': 'Zaimportuj wyciąg bankowy, aby AI Księgowy mógł zaproponować uzgodnienie bankowe.',
  'ap.agent.bank.detail': 'AI Księgowy pokazuje pozycje bankowe, które nie są jeszcze w pełni uzgodnione. Samo księgowanie nadal trzeba zatwierdzić w widoku bankowym.',
  'ap.agent.bank.detailNoStatement': 'Brak dostępnego wyciągu bankowego za ten okres.',
  'ap.agent.bank.actionImport': 'Importuj bank',
  'ap.agent.bank.blockedReason': 'Brak danych bankowych',
  'ap.agent.bank.archiveLabel': 'Zarchiwizuj gotowe wyciągi ({{count}})',
  'ap.agent.bank.archiveConfirmTitle': 'Zarchiwizuj w pełni obsłużone wyciągi bankowe',
  'ap.agent.bank.archiveConfirmWarn': 'Wyciągi zostaną przeniesione do archiwum, a okres zostanie zablokowany. Można je ponownie otworzyć w Banku.',
  'ap.agent.bank.archiveCheckedNote': 'Tylko wyciągi, w których wszystkie pozycje są obsłużone, wszystko jest zaksięgowane, a saldo się zgadza. Wszystko inne musisz zrobić w „Uzgodnij i zaksięguj”.',
  'ap.agent.bank.archiveDoneLabel': 'wyciągi zarchiwizowane',
  'ap.agent.vat.termWithNumber': 'okres {{n}}',
  'ap.agent.vat.termFallback': 'okres VAT',
  'ap.agent.vat.termWithPeriod': 'VAT {{period}}',
  'ap.agent.vat.termGeneric': 'Okres VAT',
  'ap.agent.vat.disabledTitle': 'Agent VAT nie jest aktywny',
  'ap.agent.vat.disabledDesc': 'W ustawieniach firma nie jest oznaczona jako zarejestrowana do VAT.',
  'ap.agent.vat.disabledDetail': 'AI Księgowy nie pokazuje deklaracji VAT, dopóki firma nie jest zarejestrowana do VAT.',
  'ap.agent.vat.noTermTitle': 'Brak okresu VAT w tym miesiącu',
  'ap.agent.vat.noTermDesc': 'Okres VAT firmy nie obejmuje żadnej deklaracji powiązanej z wybranym miesiącem.',
  'ap.agent.vat.noTermDetail': 'Agent terminów nadal powiadomi Cię, gdy zbliży się termin VAT. Sam okres VAT znajduje się w sekcji Deklaracje.',
  'ap.agent.vat.openFilings': 'Otwórz deklaracje',
  'ap.agent.vat.titleOverdueOne': 'Okresy VAT po terminie: {{count}}',
  'ap.agent.vat.titleOverdueMany': 'Okresy VAT po terminie: {{count}}',
  'ap.agent.vat.titleCandidatesOne': 'Okresy VAT do złożenia: {{count}}',
  'ap.agent.vat.titleCandidatesMany': 'Okresy VAT do złożenia: {{count}}',
  'ap.agent.vat.titleWaiting': 'VAT {{term}} nie jest jeszcze gotowy',
  'ap.agent.vat.titleUpToDate': 'VAT jest aktualny',
  'ap.agent.vat.descCandidates': 'Dane VAT są obliczane z księgowości i muszą zostać sprawdzone przed złożeniem.',
  'ap.agent.vat.descWaiting': 'Okres obejmuje {{period}}, a termin to {{due}}.',
  'ap.agent.vat.descDelivered': 'MVA-melding została złożona. Nadal jest widoczna tutaj, abyś mógł otworzyć okres, jeśli coś trzeba poprawić.',
  'ap.agent.vat.descNoneOpen': 'Nie znaleziono otwartych okresów VAT.',
  'ap.agent.vat.detail': 'AI Księgowy korzysta z danych VAT w Plumme. Złożenie i płatność nadal muszą zostać zatwierdzone, zanim cokolwiek zostanie wysłane.',
  'ap.agent.vat.dueNote': 'Termin {{due}}',
  'ap.agent.vat.paidNote': 'Złożono i zapłacono',
  'ap.agent.vat.filedNote': 'Złożono',
  'ap.agent.asset.title': 'Zakupy do oceny jako aktywa: {{count}}',
  'ap.agent.asset.titleEmpty': 'Brak propozycji aktywów',
  'ap.agent.asset.desc': 'Zakupów zaksięgowanych na koncie aktywów brakuje w rejestrze aktywów.',
  'ap.agent.asset.descEmpty': 'Żadnego zakupu w tym okresie nie trzeba oceniać.',
  'ap.agent.asset.detail': 'Zarejestrowane aktywa są dalej obsługiwane w rejestrze aktywów i podczas zamknięcia roku.',
  'ap.agent.asset.action': 'Otwórz aktywa',
  'ap.agent.asset.registerLabel': 'Zarejestruj środki trwałe ({{count}})',
  'ap.agent.asset.registerConfirmTitle': 'Zarejestruj środki trwałe',
  'ap.agent.asset.registerConfirmWarn': 'Zakupy otrzymają podstawę amortyzacji. Kwota, data, konto i VAT samego zakupu nie zostaną zmienione.',
  'ap.agent.asset.registerCheckedNote': 'Rejestrowane są tylko zakupy, w których konto określa grupę saldową. Jeśli grupa jest niejasna, musisz wybrać ją sam — błędna grupa oznacza błędną stawkę amortyzacji we wszystkich kolejnych latach.',
  'ap.agent.asset.registerDoneLabel': 'zarejestrowano środki trwałe',
  'ap.agent.asset.lineFallback': 'Zakup',
  'ap.agent.payroll.titleOpenOne': 'Oczekujące listy płac: {{count}}',
  'ap.agent.payroll.titleOpenMany': 'Oczekujące listy płac: {{count}}',
  'ap.agent.payroll.titleNoRuns': 'Płace nie mają otwartych list',
  'ap.agent.payroll.descOpen': 'Wynagrodzenia trzeba sprawdzić i zatwierdzić w widoku Płace.',
  'ap.agent.payroll.descApprovedOne': 'Zatwierdzone lub opłacone listy płac: {{count}}.',
  'ap.agent.payroll.descApprovedMany': 'Zatwierdzone lub opłacone listy płac: {{count}}.',
  'ap.agent.payroll.detail': 'AI Księgowy pokazuje status płac z Plumme. Zatwierdzenie i płatność odbywają się w widoku Płace. Wysyłanie A-melding do Altinn nie jest jeszcze podłączone.',
  'ap.agent.payroll.action': 'Otwórz płace',
  'ap.agent.payroll.lineFallback': 'Lista płac',
  'ap.agent.payroll.generateLabel': 'Utwórz listę płac za {{period}}',
  'ap.agent.payroll.generateConfirmTitle': 'Utwórz listę płac jako szkic',
  'ap.agent.payroll.generateConfirmWarn': 'Lista jest tworzona jako szkic na podstawie stałych składników wynagrodzenia. Nic nie zostanie wypłacone ani zaksięgowane — musisz otworzyć płace, sprawdzić każdego pracownika i samodzielnie zatwierdzić.',
  'ap.agent.payroll.generateCheckedNote': 'Zwroty kosztów podróży nie są uwzględniane. Trzeba je dodać ręcznie, aby żaden zwrot nie został wypłacony bez oceny podróży.',
  'ap.agent.payroll.generateDoneLabel': 'utworzono listę płac',
  'ap.workspace.doneCount': 'Zatwierdzone: {{count}}',
  'ap.workspace.doneNone': 'Nic jeszcze nie zatwierdzono',
  'ap.workspace.readyCountOne': 'Gotowe: {{count}}',
  'ap.workspace.readyCountMany': 'Gotowe: {{count}}',
  'ap.workspace.inboxReviewCount': 'Wiersze do sprawdzenia: {{count}}',
  'ap.workspace.remainingCount': 'Pozostało: {{count}}',
  'ap.workspace.reviewToControl': 'Do sprawdzenia: {{count}}',
  'ap.workspace.assetDetail': 'Ten sam dokument należy do kolejki księgowania. Wybierz tutaj ujęcie w kosztach lub środek trwały; zakup zostanie zaksięgowany tylko raz.',
  'ap.workspace.queueDetail': 'Propozycje są pogrupowane według agenta. Otwórz listę, aby je sprawdzić i edytować przed zatwierdzeniem.',
  'ap.workspace.openWorklist': 'Otwórz listę zadań',
  'ap.workspace.proposalModalTitle': 'Sprawdź propozycję · {{title}}',
  'ap.workspace.close': 'Zamknij',
  'ap.workspace.saveProposal': 'Zapisz propozycję',
  'ap.workspace.proposalSaveNote': 'Zapisanie zmienia propozycję, a nie księgowość. Wcześniejsze zatwierdzenie zostaje cofnięte, gdy propozycja się zmieni.',
  'ap.workspace.accountLabel': 'Konto',
  'ap.workspace.vatRateLabel': 'Stawka VAT',
  'ap.workspace.paidWithLabel': 'Zapłacono z',
  'ap.workspace.paidWithCompany': 'Konto firmowe',
  'ap.workspace.paidWithPrivate': 'Prywatnie',
  'ap.workspace.paidWithCash': 'Gotówka',
  'ap.workspace.needsReviewOption': 'Wymaga sprawdzenia',
  'ap.workspace.treatmentLabel': 'Sposób ujęcia',
  'ap.workspace.treatmentPlaceholder': 'Wybierz sposób ujęcia',
  'ap.workspace.treatmentExpense': 'Ujmij cały zakup w kosztach',
  'ap.workspace.treatmentAsset': 'Zarejestruj jako środek trwały',
  'ap.workspace.balanceGroupLabel': 'Grupa saldowa',
  'ap.workspace.balanceGroupPlaceholder': 'Wybierz grupę saldową',
  'ap.workspace.balanceGroupA': 'a · maszyny biurowe itp. (30 %)',
  'ap.workspace.balanceGroupC': 'c · samochody dostawcze itp. (24 %)',
  'ap.workspace.balanceGroupD': 'd · wyposażenie itp. (20 %)',
  'ap.workspace.typeLabel': 'Typ',
  'ap.workspace.bookingTypePurchase': 'Zakup',
  'ap.workspace.bookingTypeSale': 'Sprzedaż',
  'ap.workspace.bookingTypeUnknown': 'Wymaga obsługi w Banku',
  'ap.workspace.classificationLabel': 'Klasyfikacja',
  'ap.workspace.classificationBusiness': 'Firma',
  'ap.workspace.mileageModalTitle': 'Edytuj przejazd',
  'ap.workspace.saveTrip': 'Zapisz przejazd',
  'ap.workspace.dateLabel': 'Data',
  'ap.workspace.purposeLabel': 'Cel',
  'ap.workspace.fromLabel': 'Skąd',
  'ap.workspace.toLabel': 'Dokąd',
  'ap.workspace.kilometersLabel': 'Kilometry',
  'ap.suggestionOverrideNote': 'Możesz zmienić konto, VAT i kwotę przed zatwierdzeniem. Zmiana zastępuje propozycję autopilota.',
  'ap.payslipFor': 'Pasek wynagrodzenia dla {{name}}',
  'ap.payslipEditHelpHourly': 'Szybka korekta: dostosuj kwotę lub liczbę godzin. Reszta paska zostanie przeliczona.',
  'ap.payslipEditHelpFixed': 'Szybka korekta: dostosuj kwotę. Reszta paska zostanie przeliczona.',
  'ap.payslipBookedHelp': 'SuperPlumma zaksięgowała wynagrodzenie na 5000, zaliczkę na podatek na 2600 i składkę pracodawcy na 2770.',
  'ap.payslipCalculatedGross': 'Obliczone wynagrodzenie brutto:',
  'ap.payslipHourlyLabel': 'Stawka godzinowa',
  'ap.payslipFixedLabel': 'Stałe wynagrodzenie',
  'ap.contactsNewSuppliersTitle': 'Nowi dostawcy',
  'ap.contactsCreateSelected': 'Utwórz wybrane ({{count}})',
  'ap.contactsProposedCount': 'Proponowane ({{noun}}): {{count}}',
  'ap.contactsFoundNote': 'SuperPlumma znalazła księgowania bez zarejestrowanego kontrahenta ({{noun}}). Zapisz ich w {{list}}, aby przyszłe księgowania były łączone automatycznie.',
  'ap.contactsInclude': 'Uwzględnij',
  'ap.openingVoucher': 'Otwieranie: {{name}}',
  'ap.sendReminder': 'Wyślij przypomnienie',
  'ap.sendInvoice': 'Wyślij fakturę',
  'ap.clickToSeePayslipLines': 'Kliknij, aby zobaczyć składniki wynagrodzenia',
  'ap.clickToEditProposal': 'Kliknij, aby edytować propozycję',
  'ap.clickToOpenWorkArea': 'Kliknij, aby otworzyć obszar roboczy',
  'ap.ignoreThisMonth': 'Ignoruj w tym miesiącu',
  'ap.entryCancelled': 'Księgowanie zostało anulowane',
  'ap.entryUpdated': 'Księgowanie zaktualizowane 🟣',
  'ap.approvalReopened': 'Zatwierdzenie zostało cofnięte. Zadanie jest ponownie otwarte.',
  'ap.reopenTaskError': 'Nie udało się ponownie otworzyć zadania.',
  'ap.proposalsBookedToast': 'Zatwierdzone i zaksięgowane propozycje: {{count}}.',
  'ap.approveBookError': 'Nie udało się zatwierdzić i zaksięgować propozycji.',
  'ap.proposalUpdatedToast': 'Propozycja została zaktualizowana i musi zostać ponownie zatwierdzona.',
  'ap.lineHiddenToast': 'Wiersz jest ukryty w tym miesiącu i wróci w przyszłym miesiącu, jeśli nadal będzie otwarty.',
  'ap.voucherLinkedToast': 'Dokument został powiązany z wierszem bankowym. Propozycja jest oceniana ponownie.',
  'ap.mileageFillRequired': 'Uzupełnij datę, skąd, dokąd, cel i kilometry.',
  'ap.mileageSaveUnavailable': 'Zapisywanie ewidencji przebiegu jest niedostępne.',
  'ap.mileageUpdatedToast': 'Przejazd został zaktualizowany.',
  'ap.noActiveAgentsText': 'SuperPlumma jest gotowa, ale obecnie żaden agent nie jest aktywny. Włącz agentów, z których chcesz korzystać, w ustawieniach powyżej, a zespół zajmie się twoją księgowością.',
  'ap.vatSurface.emptyTitle': 'Brak okresu VAT do złożenia',
  'ap.vatSurface.emptyDesc': 'Wszystkie okresy w roku są oznaczone jako złożone.',
  'ap.vatSurface.pickPrompt': 'Wybierz okres VAT, który chcesz sprawdzić i złożyć.',
  'ap.vatSurface.termFallback': 'Okres VAT',
  'ap.vatSurface.title': 'MVA-melding',
  'ap.vatSurface.openSubmissions': 'Otwórz złożone deklaracje',
});
